// // ScanPallet.js
// import React, { useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { toast, ToastContainer } from 'react-toastify';
// import { useLoading } from '../utils/loading/LoadingContext';
// import LoadingIndicator from '../utils/loading/LoadingIndicator';
// import 'react-toastify/dist/ReactToastify.css';

// const ScanToPallet = () => {
//     const { palletNumber } = useParams(); // Get pallet number from the URL
//     const [identifier, setIdentifier] = useState('');
//     const [processedBols, setProcessedBols] = useState([]);
//     const [lastBolStatus, setLastBolStatus] = useState('');
//     const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
//     const { isLoading, setLoading } = useLoading();
//     const navigate = useNavigate();

//     const handleScan = (e) => {
//         e.preventDefault();
//         setLoading(true);
//         fetch(`${baseUrl}/api/pallet_scan/`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//                 pallet_number: palletNumber,
//                 identifier,
//                 action: 'scan'
//             }),
//         })
//             .then(response => response.json())
//             .then(data => {
//                 setProcessedBols(data.processed_bols);
//                 setLastBolStatus(data.last_bol_status);
//                 toast.success('Item scanned successfully');
//                 setIdentifier('');
//                 setLoading(false);
//             })
//             .catch(error => {
//                 console.error('Error scanning item:', error);
//                 toast.error('Failed to scan item');
//                 setLoading(false);
//             });
//     };

//     return (
//         <div className="scanPallet-body">
//             {isLoading && <LoadingIndicator />}
//             <h2>Scan into Pallet {palletNumber}</h2>
//             <form onSubmit={handleScan}>
//                 <input
//                     type="text"
//                     value={identifier}
//                     onChange={(e) => setIdentifier(e.target.value)}
//                     placeholder="Enter BOL or PkgID"
//                     required
//                 />
//                 <button type="submit">Scan</button>
//             </form>
//             <div className="processed-bols">
//                 <h3>Recently Processed BOLs</h3>
//                 <ul>
//                     {processedBols.map((bol, index) => (
//                         <li key={index}>{bol}</li>
//                     ))}
//                 </ul>
//             </div>
//             <ToastContainer />
//         </div>
//     );
// };

// export default ScanToPallet;


import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLoading } from "../utils/loading/LoadingContext";
import "./styles/scantool.css"; // Make sure the path is correct
import success from "../assets/images/check.png";
import not_found from "../assets/images/cross.png";
import invalid_format from "../assets/images/warning.png";
import already_processed from "../assets/images/exist.png";
import { useParams, useNavigate } from 'react-router-dom';
import no_status from "../assets/images/no_status.png";
import high_value from "../assets/images/high_value.png";

// Import audio files
import successAudio from "../assets/audios/success.mp3";
import highValueAudio from "../assets/audios/high_value.mp3";
import alreadyProcessedAudio from "../assets/audios/exist.mp3";
import invalidFormatAudio from "../assets/audios/error.mp3";
import notFoundAudio from "../assets/audios/error.mp3";
import { actions } from "react-table";

// Map status to images
const statusImages = {
  success: success,
  not_found: not_found,
  invalid_format: invalid_format,
  already_processed: already_processed,
  no_status: no_status,
  high_value: high_value,
};

// Map status to audio elements
const statusAudios = {
  success: successAudio,
  high_value: highValueAudio,
  already_processed: alreadyProcessedAudio,
  invalid_format: invalidFormatAudio,
  not_found: notFoundAudio,
};

const ScanToPallet = () => {
  const [identifier, setIdentifier] = useState("");
  const { setLoading } = useLoading();
  const inputRef = useRef(null);
  const { palletNumber } = useParams();
  const formatDate = (dateString) => {
    const options = {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  };

  const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;

  const [successfulBOLs, setSuccessfulBOLs] = useState(() => {
    const savedBOLs = localStorage.getItem("successfulBOLs");
    return savedBOLs ? JSON.parse(savedBOLs) : [];
  });

  const [results, setResults] = useState({
    processedBols: [],
    lastBolStatus: "",
    messages: [],
    scanned_date: "",
    scanned_by: "",
    total_units: "",
  });

  const handleInputChange = (e) => {
    const inputWithoutSpaces = e.target.value.replace(/\s+/g, "");
    setIdentifier(inputWithoutSpaces);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/pallet_scan/`,
        { pallet_number: palletNumber,
            identifier,
        action :'scan'

         },
         config
      );
      setResults({
        processedBols: response.data.processed_bols,
        lastBolStatus: response.data.last_bol_status,
        messages: response.data.messages,
        scanned_date: response.data.scanned_date,
        scanned_by: response.data.scanned_by,
        total_units: response.data.total_units,
      });

      // Play audio corresponding to the status
      const audioSrc = statusAudios[response.data.last_bol_status];
      if (audioSrc) {
        const audioElement = new Audio(audioSrc);
        audioElement.play();
      }

      if (response.data.last_bol_status === "success" ||
        response.data.last_bol_status === "high_value") {
        const updatedBOLs = [
          ...successfulBOLs,
          {
            identifier: identifier,
            scanned_date: response.data.scanned_date,
            scanned_by: response.data.scanned_by,
            total_units: response.data.total_units,
          },
        ];
        setSuccessfulBOLs(updatedBOLs);
        localStorage.setItem("successfulBOLs", JSON.stringify(updatedBOLs));
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
    }

    setLoading(false);
    setIdentifier("");
    inputRef.current.focus();
  };

  // Focus the input when component mounts
  useEffect(() => {
    inputRef.current.focus();
  }, []);

  return (
    <div className="whole-container">
      <div className="scan-container">
        <h1>Scan To Pallet Number {palletNumber}</h1>
        <form className="scan-form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="large-input" // Applied large-input class for styling
            value={identifier}
            onChange={handleInputChange}
            placeholder="Scan..."
            ref={inputRef}
          />
          <button type="submit">Submit</button>
        </form>
      </div>

      {results.messages.length > 0 ? (
        <div className={`message ${results.lastBolStatus}`}>
          <div>
            <img
              className="status-image"
              src={statusImages[results.lastBolStatus]}
              alt="Status Icon"
            />
          </div>
          {results.messages.map((message, index) => (
            <div key={index} className={`message ${message.type}`}>
              <p>{message}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="message no_status">
          <div>
            <img className="status-image" src={no_status} alt="No Status" />
          </div>
          <div className="message no_status">
            <p>Let's Start!</p>
          </div>
        </div>
      )}

      <div className="table-container">
        {successfulBOLs.length > 0 && (
          <div>
            <h2>Recent BOLs</h2>
            <table>
              <thead>
                <tr>
                  <th>Scanned By</th>
                  <th>BOL / PkgID</th>
                  <th>Total Units</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {[...successfulBOLs].reverse().map((bol, index) => (
                  <tr key={index}>
                    <td>{bol.scanned_by}</td>
                    <td>{bol.identifier}</td>
                    <td>{bol.total_units}</td>
                    <td>{formatDate(bol.scanned_date)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScanToPallet;